import { useSelector } from 'react-redux';
import { offerSelector } from 'shared/selectors';
import { EFeaturesGroupID, IFeatures } from 'shared/types/features';
import { getOfferType, isUrban } from 'shared/utils/offer_type';

export const useShowSubscribeBtn = (feature: IFeatures | null): boolean => {
  const offer = useSelector(offerSelector);
  const offerType = getOfferType(offer);

  const isUrbanOffer = isUrban(offerType);

  const isBuildingOffer = feature?.id === EFeaturesGroupID.AboutBuilding;

  return isUrbanOffer && isBuildingOffer;
};
